"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassName = void 0;
var ClassName;
(function (ClassName) {
    ClassName["DECISION"] = "DECISION";
    ClassName["LEGIS"] = "LEGIS";
})(ClassName || (exports.ClassName = ClassName = {}));
//# sourceMappingURL=raw.js.map